<!-- Check if customer is available and if data is still loading -->
<div class="container" *ngIf="!employerContactSubscription && auth.isLoading$ | async; else loaded">
  <app-loading></app-loading>
</div>

<ng-template #loaded>
  <mat-card class="profile-data-mat-card" *ngIf="auth.user$ | async as user" [@fadeIn]="fadeIn">
    <!-- User Profile Info -->
    <mat-card-header>
      <mat-card-title>Cancel Subscription</mat-card-title>
    </mat-card-header>
    <br />
    <mat-card-content *ngIf="employerContactSubscription">
      <div *ngIf="this.employerContactSubscription.contactPermissions.employerAdmin == false" [@fadeIn]="fadeIn">
        <p> This is not a place for you please return to the <a href="/"> home page</a>!</p>
      </div>
      <div *ngIf="!employerContactSubscription && userType === 'E'"><app-loading></app-loading></div>
      Thinking of cancelling? We recommend switching to a lower tier plan so you can:
      <ul>
        <li>Actively stay in the platform, even when recruiting efforts have slowed down. Recruiting truly never stops,
          so staying in the Basic tier will allow you to stay connected with other employers and workers year-round.
          Employers are connecting with opposite-season organizations for recruiting throughout the course of the year.
        </li>

        <li>Keep a job posted so workers looking at employers in the platform to determine options for places to work
          next season know your organization will be hiring.</li>

        <li>Attend Seasonal Connect virtual and in-person events.</li>

        <li>Keep your information in the platform so you do not need to create a new profile like you would if you
          cancelled and returned.</li>
      </ul>
      <div *ngIf="employerContactSubscription" class="center">
        <button mat-raised-button class="light-blue" [routerLink]="['/change-subscription']" [@fadeIn]="fadeIn">Change
          My Plan</button>
      </div>

      <p>Still want to cancel? This action cannot be undone. By cancelling your subscription you will lose all of your
        data in the platform and will only be able to use Seasonal Connect until the end of your subscription period.
      </p>

         <!-- Cancellation Reason Dropdown -->
         <mat-form-field appearance="outline" class="reason-dropdown">
          <mat-label>Cancellation Reason</mat-label>
          <mat-select [formControl]="cancelationReason">
            <mat-option *ngFor="let reason of cancelationReasons" [value]="reason">
              {{ reason }}
            </mat-option>
          </mat-select>
        </mat-form-field>

      <div fxLayout="row" fxLayout.lt-md="column" fxLayoutGap="16px">
        <!-- Statement and Payment Method buttons -->
        <div class="actions" fxFlex="33">
          <button mat-raised-button class="submit-button" [routerLink]="['/']">Back</button>
      </div>
      <div class="actions" fxFlex="33">
        <div *ngIf="employerContactSubscription" class="center" [@fadeIn]="fadeIn">
          <div fxLayout="column" fxLayoutGap="10px">
      
         
      
            <!-- Cancel Subscription Button -->
            <button mat-raised-button color="warn"
                    (click)="openConfirmationDialog()"
                    [disabled]="!cancelationReason.valid">
              Cancel My Subscription
            </button>
      
          </div>
        </div>
      </div>
      
      
        <div class="actions" fxFlex="33">

        </div>

      </div>
    </mat-card-content>
  </mat-card>
  <br />
</ng-template>